import '.././App.css';

function Footer() {

    return (
        <footer className="footer">
            <p>Copyright © 2019-{new Date().getFullYear()} Alexey Koval. All rights reserved.</p>    
            <div className="links">
                <a href="https://www.artstation.com/kridaran">ArtStation</a>                
                <a href="https://www.instagram.com/kridaran/">Instagram</a>
                <a href="https://www.youtube.com/channel/UCLT0xAMCHQYoVB5ohPj8Zhw">YouTube</a>
                <a href="https://games-by-kov.web.app/">Old site</a>
                <p>kovgamesinfo@gmail.com</p>
            </div>
        </footer>
    );

}

export default Footer;